module.exports = __webpack_public_path__ + "img/2.2485e8a1.png";